import React, { useMemo } from 'react';

import './no-data.scss';

const NoData = ({ error = false }) => {
  const noResultsText = useMemo(
    () =>
      error
        ? 'Service is unavailable for now. Please, try again later'
        : 'No data found',
    [error]
  );

  return (
    <div className="no-data-wrapper">
      <span>{noResultsText}</span>
    </div>
  );
};

export default NoData;
